/**
 * Blocks checkout when Indendørs cart lines are below the minimum m² quantity.
 */
(function () {
  /** @typedef {{ line: number, quantity: number, minimum: number, title: string }} CartSqmLine */

  /** @type {boolean} */
  let cartErrorsShown = false;

  /** @returns {CartSqmLine[]} */
  function readCartSqmLines() {
    const node = document.querySelector('[data-cart-sqm-minimums]');
    if (!(node instanceof HTMLScriptElement) || !node.textContent) return [];

    try {
      const parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  /** @returns {CartSqmLine[]} */
  function getViolations() {
    return readCartSqmLines().filter((line) => line.quantity < line.minimum);
  }

  /** @returns {boolean} */
  function isCartBlocked() {
    return getViolations().length > 0;
  }

  function updateBlocking() {
    const blocked = isCartBlocked();
    const errorEl = document.querySelector('[data-cart-sqm-minimum-error]');

    if (errorEl instanceof HTMLElement) {
      errorEl.hidden = !(blocked && cartErrorsShown);
    }
  }

  function revealCartError() {
    cartErrorsShown = true;
    updateBlocking();
    document.querySelector('[data-cart-sqm-minimum-error]')?.scrollIntoView({ block: 'nearest' });
  }

  function bindCartForm() {
    const cartForm = document.getElementById('cart-form');
    if (!(cartForm instanceof HTMLFormElement) || cartForm.dataset.cartSqmMinimumFormBound === 'true') {
      return;
    }

    cartForm.dataset.cartSqmMinimumFormBound = 'true';
    cartForm.addEventListener(
      'submit',
      (event) => {
        const submitter = event.submitter;
        if (!(submitter instanceof HTMLElement)) return;
        if (submitter.name !== 'checkout') return;
        if (!isCartBlocked()) return;

        event.preventDefault();
        event.stopPropagation();
        revealCartError();
      },
      true
    );
  }

  function bindCheckoutScopes() {
    document.querySelectorAll('[data-checkout-acceptance-scope]').forEach((scope) => {
      if (!(scope instanceof HTMLElement) || scope.dataset.cartSqmMinimumScopeBound === 'true') return;
      scope.dataset.cartSqmMinimumScopeBound = 'true';

      scope.querySelectorAll('.cart__checkout-button').forEach((btn) => {
        btn.addEventListener(
          'click',
          (event) => {
            if (!isCartBlocked()) return;

            event.preventDefault();
            event.stopPropagation();
            revealCartError();
          },
          true
        );
      });
    });
  }

  function init() {
    cartErrorsShown = false;
    bindCartForm();
    bindCheckoutScopes();
    updateBlocking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:update', init);
  document.addEventListener('shopify:section:load', init);
})();
